import * as React from 'react';
import {withRouter, useHistory} from 'react-router-dom';

import {Carousel} from 'antd';

import {List} from '@common/typescript/objects/List';

import Musthead from '@app/components/UI/MustHead/Musthead';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import FiftyFifty from '@app/components/UI/FiftyFifty/FiftyFifty';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import RichText from '@app/components/UI/RichText/RichText';
import SloganBlockSmall from '@app/components/UI/SloganBlock/SloganBlockSmall';
import {
	euthanasiaEmbedText,
	euthanasiaFiftyText,
	euthanasiaFiftyTitle,
	euthanasiaLinkItems,
	euthanasiaServicesTitle,
	euthanasiaServices,
	appointmentInformation,
	appointmentInformation2, sliderItems
} from '@app/components/Pages/Services/Euthanasia/euthanasiaContent';
import FaqBlockHeaderSm from '@app/components/UI/FaqBlock/FaqBlockHeaderSm';
import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import {Questions} from '@app/objects/Questions';
import {rest} from '@app/components/Api';
import GetInTouchButton from '@app/components/Forms/GetInTouch/GetInTouchButton';
import EuthanasiaSlider from '@app/components/Pages/Services/Euthanasia/EuthanasiaSlider';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

const Euthanasia = () => {
	const [questions, setQuestions] = React.useState<Questions[]>([]);
	const history = useHistory();
	const [isMobile, setIsMobile] = React.useState(false);

	React.useEffect(() => {
		rest.get<List<Questions>>('v1/faq/euthanasiaPage').then(res => setQuestions(res.list));
	}, []);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 600px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	return (
		<div className="in-home-euthanasia our-services">
			<Musthead
				title="In-Home Pet Euthanasia"
				imageSrc={require('@app/content/euthanasia.jpg')}
				text="At some point, we move from ensuring a quality of life to ensuring a quality of death."
				quoteAuthor="Dr. Mary Gardner"
				imageAlt="In-home pet euthanasia"
			/>
			<VideoEmbed
				text={euthanasiaEmbedText}
				videoSrc="https://player.vimeo.com/video/218718960?color=ed261f&title=0&byline=0&portrait=0"
				videoTitle="See how we’ve helped our families."
			/>
			<FiftyFifty
				title={euthanasiaFiftyTitle}
				text={euthanasiaFiftyText}
				src={require('@app/content/In-home-euthanasia-lap-of-love.jpg')}
				alt="In-home euthanasia Lap of Love"
			/>
			<RichText
				title={euthanasiaServicesTitle}
				text={euthanasiaServices}
			/>
			<SloganBlockSmall
				title="Need to talk to someone about in-home euthanasia?"
				btnText={isMobile
					? <a className="btn btn-md btn-primary" href="tel:855-933-5683">Call Us</a>
					: <GetInTouchButton btnText="Schedule Appointment" />}
				onBtnClick={() => {}}
				styled="slogan-block-small_white"
			/>

			<EuthanasiaSlider />

			<RichText
				title=""
				text={appointmentInformation2}
			/>
			<SloganBlockSmall
				title="Looking for in-home pet euthanasia in your area?"
				btnText="Find a vet near you"
				onBtnClick={() => { history.push('/find-a-vet'); }}
				styled="slogan-block-small_white"
			/>

			{/*classes should be fixed*/}
			<div className="care-coordinator__faq">
				<div className="care-coordinator__faq-content">
					<FaqBlockHeaderSm
						title="You might find yourself asking..."
						btnText="View all FAQ"
						clickUrl="/faq"
					/>
					<FaqBlock questions={questions} />
				</div>
			</div>
			<LinkBlockSmall items={euthanasiaLinkItems}/>
		</div>
	);
};

export default withRouter(withSeo(Euthanasia, state => state.euthanasiaPage, 'euthanasiaPage', 'our-services/in-home-euthanasia'));